// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1pyRt","header":"PatientQuestionnaire_header__EcL2Q","info":"PatientQuestionnaire_info__3aVQ5"};